import React from 'react';
import PropTypes from 'prop-types';
import { Add as AddIcon } from '@mui/icons-material';

import { isMobile } from '../../../../../common/services/isMobile';
import { Toolbar } from '../../../../../common/components/Toolbar/Toolbar';
import Button from '../../../../../common/components/Button/Button';

export const pageLabelStyle = {
  display: 'flex',
  alignItems: 'center',
  fontWeight: 700,
};

function DictionaryToolbar(props) {
  const { title, openCreateDialog, buttons, hidePageLabel, hideAddButton } = props;

  const pageLabel = (!isMobile || !hidePageLabel) && (
    <div style={pageLabelStyle}>
      <div className="title">{title}</div>
      <span className="toolbar-separator" />
    </div>
  );

  const creationButton = !hideAddButton && openCreateDialog && (
    <Button className="dictionary-toolbar-btn" onClick={openCreateDialog} variant="contained">
      <AddIcon /> Add
    </Button>
  );

  return (
    <Toolbar>
      {pageLabel}
      {creationButton}
      {buttons}
    </Toolbar>
  );
}

DictionaryToolbar.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  buttons: PropTypes.node,
  openCreateDialog: PropTypes.func,
};

export default DictionaryToolbar;
